import { Popover, Tooltip } from '@material-ui/core';
import React from 'react';

function PopData(props)
{

	const { id, open, handleClose, anchorEl, webinarData, popData } = props;

	const attachHttps=(url) =>
	{
		if (url.indexOf('https://') === -1)
		{
			url = `https://${ url}`;
		}

		return url;
	};

	return (
		<Popover
			id={id}
			open={open}
			onClose={handleClose}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical   : 'bottom',
				horizontal : 'left'
			}}
			transformOrigin={{
				vertical   : 'top',
				horizontal : 'left'
			}}
		>
			<div className='flexAutoCol vBio pRel brdrRadiusMD'>
				<img src={popData?.speakerImage?.publicUrl ? `${popData?.speakerImage?.publicUrl }/${ popData?.speakerImage?.key}` : '/themeAvatar2.svg'} className={webinarData?.profileImage ? 'crdImg' : 'crdImgNone'} alt='img' />
				<div className='flexAutoCol pdngSM jBtwn flDiv pAbs'>
					<div className='flexCol pdngBXS brdrBSM'>
						<span className='txtBlBoldSM capTxt ellipsisTxt'>{popData?.speakerName}</span>
						<span className='small ellipsisTxt'>{popData?.speakerEmail}</span>
					</div>
					<div className='flexCol pdngBXS brdrBSM'>
						<span className='capTxt sHdng ellipsisTxt'>{popData?.organization}</span>
						<span className='small'>Speaker</span>
					</div>
					<div className='flexRow gap16'>
						{ popData.facebookUrl &&
						<Tooltip placement='top' title={popData.facebookUrl}>
							<a className='termLinks' href={attachHttps(popData.facebookUrl)} target='_blank' rel='noreferrer' >
								<img className='pointer' src='/webinar/fb.svg' alt='fb' />
							</a>
						</Tooltip> }
						{ popData.linkedinUrl &&
						<Tooltip placement='top' title={popData.linkedinUrl}>
							<a className='termLinks' href={attachHttps(popData.linkedinUrl)} target='_blank' rel='noreferrer' >
								<img className='pointer' src='/webinar/link.svg' alt='link' />
							</a>
						</Tooltip> }
						{ popData.twitterUrl &&
						<Tooltip placement='top' title={popData.twitterUrl}>
							<a className='termLinks' href={attachHttps(popData.twitterUrl)} target='_blank' rel='noreferrer' >
								<img className='pointer' src='/webinar/tweet.svg' alt='tweet' />
							</a>
						</Tooltip> }
						{ popData.websiteUrl &&
						<Tooltip placement='top' title={popData.websiteUrl}>
							<a className='termLinks' href={attachHttps(popData.websiteUrl)} target='_blank' rel='noreferrer' >
								<img className='pointer' src='/webinar/globe.svg' alt='globe' />
							</a>
						</Tooltip> }
					</div>
				</div>
			</div>
		</Popover>
	);
}

export default PopData;